import React from 'react'
import { connect } from 'react-redux'
import { Badge, Box, Button, TextField } from '@mui/material'
import classNames from 'classnames'
import { sendWs, PUSH, BOARD_TEXT } from '../../lib/send'
import { promptBoard } from '../../lib/dialog'
import { rxGamepad } from '../../lib/rx_subject'
import { gamepadButtonName } from '../../lib/gamepad'
import './Actions.scss'

const Player = ({ className, hidden, browser: { mobile }, setting: { personal: { bind } }, selfID, rule, board: { bg } }) => {
  const [focus, setFocus] = React.useState(false)
  const [answer, setAnswer] = React.useState('')

  const blockEl = React.useRef(null)
  const boardEl = React.useRef(null)
  const subscription = React.useRef(null)

  let recentlyPushed = false

  const onPush = evt => {
    if (!recentlyPushed) {
      sendWs(PUSH)
      recentlyPushed = true
      setTimeout(() => {
        recentlyPushed = false
      }, 500)
    }
  }

  const onKeyDown = evt => {
    switch (evt.keyCode) {
      case 13:
        if (bind.key.answer === 'Enter') {
          sendWs(PUSH)
        }
        break
      case 32:
        if (bind.key.answer === 'Space') {
          sendWs(PUSH)
        }
        break
      case 27: // ESC
        if (rule.board.active) {
          boardEl.current.focus()
        }
        break
      default:
        break
    }
  }

  const onFocus = evt => {
    if (evt.target.className.split(' ').includes('actions-content')) {
      setFocus(true)
    }
    subscription.current = rxGamepad.subscribe(button => {
      if (button === bind.gamepad.answer) {
        sendWs(PUSH)
      }
    })
  }

  const onBlur = evt => {
    if (evt.target.className.split(' ').includes('actions-content')) {
      setFocus(false)
    }
    if (subscription.current) {
      subscription.current.unsubscribe()
    }
  }

  const onKeyDownBoard = evt => {
    evt.stopPropagation()
    if (evt.keyCode === 27) {
      blockEl.current.focus()
    }
  }

  const sendAnswer = evt => {
    evt.preventDefault()
    sendBoard(answer)
    setAnswer('')
    blockEl.current.focus()
  }

  const sendAnswerMobile = () => {
    promptBoard(sendBoard)
  }

  const sendBoard = text => {
    sendWs(BOARD_TEXT, text)
  }

  const boardInput = (
    <Box>
      <form onSubmit={sendAnswer} className="boardactions-content">
        <Badge color="primary" overlap="circular"
               badgeContent="ESC" invisible={!focus}>
          <TextField id="message" variant="outlined" size="small"
                     className="board-answer" autoComplete="off"
                     inputRef={boardEl}
                     inputProps={{ maxLength: 1000 }}
                     disabled={bg.lock} value={answer}
                     onChange={evt => setAnswer(evt.target.value)}
                     onKeyDown={onKeyDownBoard} />
        </Badge>
        <Button type="submit" variant="outlined" color="mono" size="large"
                className="board-answer-button" disabled={bg.lock}>
          ボード解答
        </Button>
      </form>
    </Box>
  )

  const boardInputMobile = (
    <Button disabled={bg.lock}
            onClick={sendAnswerMobile}>
      ボード
    </Button>
  )

  return (
    <Box className={classNames(className, 'player-actions', { hidden })}
         tabIndex="0" ref={blockEl}
         onKeyDown={onKeyDown} onFocus={onFocus} onBlur={onBlur}>
      <Box className="content">
        <Badge color="primary" overlap="circular"
               badgeContent={bind.key.answer}
               invisible={!focus}>
          <Badge color="secondary" overlap="circular"
                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                 badgeContent={gamepadButtonName(bind.gamepad.answer)}
                 invisible={!focus || bind.gamepad.answer === null}>
            <Button variant="outlined" color="primary" size="large"
                    className="answer-button"
                    onMouseDown={onPush} onTouchStart={onPush}>
              早押し
            </Button>
          </Badge>
        </Badge>
        {rule.board.active && (mobile ? boardInputMobile : boardInput)}
      </Box>
    </Box>
  )
}

export default connect(
  state => ({
    browser: state.browser,
    setting: state.setting,
    selfID: state.selfID,
    rule: state.rule,
    board: state.board
  })
)(Player)
